<template>
    <div class="dialog-card">
        <!-- Header with gradient using bgColor prop -->
        <div class="dialog-header">
        <div class="d-flex align-center">
            <img :src="snippedlogo || logoRemovebg" alt="logo" style="height: 30px; width: auto; max-width: 60px; object-fit: contain;">
        </div>
        <div class="d-flex align-center" style="">
            <v-btn icon size="small" variant="text" style="color: white; height: 30px; width: 30px;">
            <v-icon>mdi-magnify-plus-outline</v-icon>
            </v-btn>
            <v-btn icon size="small" variant="text" style="color: white; height: 30px; width: 30px;">
            <v-icon>mdi-window-minimize</v-icon>
            </v-btn>
        </div>
        </div>

        <!-- Sub-header with white background -->
        <div class="dialog-subheader">
        <span style="font-size: 10px; font-weight: 500; color: #18181B;">Model 1 (Azure GPT 4o)</span>
        <v-btn variant="outlined" size="small" style=" border-color: #C32E0E; color: #C32E0E; text-transform: none; border-radius: 8px;">
            Login
        </v-btn>
        </div>

        <!-- Chat conversation area -->
        <div class="dialog-chat-area">
        <!-- User message -->
        <div class="d-flex justify-end align-center mb-2">
            <span class="mr-2" style="font-size: 8px; color: #71717A;">22 Oct, 10:32 AM</span>
            <div class="user-message" :style="`background: ${bgColor ? bgColor + '1A' : 'rgba(195, 46, 14, 0.10)'};`">
            Hello
            </div>
        </div>

        <!-- GPT response -->
        <div class="d-flex justify-start align-center mb-2">
            <div class="gpt-message">
            Hi! How can I help you today?
            </div>
            <span class="ml-2" style="font-size: 8px; color: #71717A;">22 Oct, 10:32 AM</span>
        </div>

        <!-- Another user message -->
        <div class="d-flex justify-end align-center mb-2">
            <span class="mr-2" style="font-size: 8px; color: #71717A;">22 Oct, 10:33 AM</span>
            <div class="user-message" :style="`background: ${bgColor ? bgColor + '1A' : 'rgba(195, 46, 14, 0.10)'};`">
                I need help with my account settings
            </div>
        </div>
        </div>

        <!-- Message input area -->
        <div class="dialog-footer">
        <v-textarea
            placeholder="Type your message here..."
            variant="outlined"
            rows="1"
            hide-details
            class="dialog_text_area"
            style="font-size: 8px; "
        ></v-textarea>
        <div class="d-flex justify-end mt-1">
            <span style="font-size: 8px; color: #71717A;">0/200000</span>
        </div>
        </div>
    </div>
</template>

<script>
import logoRemovebg from '@/assets/images/logo-removebg-preview@3x.png';
export default {
    props: {
        snippedlogo: {
            type: String,
            required: false,
            default: ''
        },
        bgColor: {
            type: String,
            required: false,
            default: '#C32E0E'
        }
    },
    data() {
        return {
            logoRemovebg: logoRemovebg
        }
    },
    methods: {
        lightenColor(color) {
            if (!color) return '#E85D3F';
            
            // Remove # if present
            let hex = color.replace('#', '');
            
            // Convert hex to RGB
            let r = parseInt(hex.substring(0, 2), 16);
            let g = parseInt(hex.substring(2, 4), 16);
            let b = parseInt(hex.substring(4, 6), 16);
            
            // Lighten by adding to RGB values (mix with white)
            r = Math.min(255, r + 50);
            g = Math.min(255, g + 50);
            b = Math.min(255, b + 50);
            
            // Convert back to hex
            return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
        }
    }
};
</script>
<style scoped>
    .dialog-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 350px;
  width: 80%;
  background: white;
  box-shadow: none;
  border-radius: 12px;
  border: 1px solid #E4E4E7;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: linear-gradient(90deg, #C32E0E 0%, #E85D3F 100%);
  border-radius: 12px 12px 0 0;
}

.dialog-subheader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: white;
}

.dialog-chat-area {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  background: white;
}

.dialog-footer {
  padding: 8px;
  background: white;
}

.user-message {
  background: rgba(195, 46, 14, 0.10);
  color: #18181B;
  padding: 6px 10px;
  border-radius: 18px 2px 18px 18px;
  font-size: 10px;
  max-width: 80%;
  word-wrap: break-word;
}

.gpt-message {
  background: white;
  color: #18181B;
  padding: 6px 0px;
  border-radius: 18px 18px 18px 2px;
  font-size: 10px;
  max-width: 80%;
  word-wrap: break-word;
}

.dialog_text_area :deep(.v-field__input) {
  padding: 12px 4px;
  font-size: 10px;
}
.dialog_text_area :deep(.v-field) {
    border-radius: 14px;
    padding: 8px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
}
</style>